import { useMutation } from "@tanstack/react-query";
import { deleteUserInvitation } from "../../services/users";

export default function useDeleteUserInvitation() {
  return useMutation(({ auth0InvitationId }: { auth0InvitationId: string }) =>
    deleteUserInvitation(auth0InvitationId)
  );
}
